"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchUserAccountDataSelector = exports.stytchPhoneSelector = exports.stytchEmailSelector = exports.stytchCryptoSelector = exports.stytchWarningSlotSelector = exports.stytchLoadingSlotsSelector = exports.stytchLoadingSlotSelector = exports.stytchStepSelector = exports.stytchAuthenticatedSelector = exports.stytchStateSelector = exports.stytchReducer = exports.initialStytchState = void 0;
// TODO: resolve this exception after release
/* eslint-disable import/max-dependencies */
const toolkit_1 = require("@reduxjs/toolkit");
const stytchClearStoreSaga_1 = require("./stytchClearStoreSaga");
const stytchCryptoExchangeCodeSaga_1 = require("./stytchCryptoExchangeCodeSaga");
const stytchCryptoSignInSaga_1 = require("./stytchCryptoSignInSaga");
const stytchCryptoSignUpSaga_1 = require("./stytchCryptoSignUpSaga");
const stytchEmailExchangeCodeSaga_1 = require("./stytchEmailExchangeCodeSaga");
const stytchEmailResendMessageSaga_1 = require("./stytchEmailResendMessageSaga");
const stytchEmailSignInSaga_1 = require("./stytchEmailSignInSaga");
const stytchEmailSignUpSaga_1 = require("./stytchEmailSignUpSaga");
const stytchGetCurrentUserSaga_1 = require("./stytchGetCurrentUserSaga");
const stytchLoadingSlot_1 = require("./stytchLoadingSlot");
const stytchPhoneExchangeCodeSaga_1 = require("./stytchPhoneExchangeCodeSaga");
const stytchPhoneResendCodeSaga_1 = require("./stytchPhoneResendCodeSaga");
const stytchPhoneSignInSaga_1 = require("./stytchPhoneSignInSaga");
const stytchPhoneSignUpSaga_1 = require("./stytchPhoneSignUpSaga");
const stytchSetAuthenticatedSaga_1 = require("./stytchSetAuthenticatedSaga");
const stytchStep_1 = require("./stytchStep");
const stytchWarning_1 = require("./stytchWarning");
exports.initialStytchState = {
    isAuthenticated: false,
    step: stytchStep_1.StytchStep.START,
    email: {
        userId: null,
        email: null,
        termsAccepted: false,
        enableNewsletter: false,
        tokenExchangeSuccess: undefined,
    },
    crypto: {
        challenge: null,
        userId: null,
        isUserCreated: null,
        termsAccepted: false,
        enableNewsletter: false,
    },
    phone: {
        phone: null,
        phoneId: null,
        userId: null,
        isUserCreated: null,
        termsAccepted: false,
        enableNewsletter: false,
    },
    loadingSlots: {},
    validationWarning: {},
    userAccountData: null,
};
exports.stytchReducer = (0, toolkit_1.createReducer)(exports.initialStytchState, (builder) => builder
    .addCase(stytchClearStoreSaga_1.stytchClearStore, () => exports.initialStytchState)
    .addCase(stytchSetAuthenticatedSaga_1.stytchSetAuthenticated, (state, { payload }) => {
    return {
        ...state,
        isAuthenticated: payload,
    };
})
    .addCase(stytchStep_1.stytchSetStep, (state, { payload }) => {
    return {
        ...state,
        step: payload,
    };
})
    .addCase(stytchLoadingSlot_1.stytchSetLoadingSlot, (state, { payload: { slot, loading } }) => {
    return {
        ...state,
        loadingSlots: {
            ...state.loadingSlots,
            [slot]: loading,
        },
    };
})
    .addCase(stytchWarning_1.stytchSetWarning, (state, { payload: { slot, isValid, message } }) => {
    return {
        ...state,
        validationWarning: {
            ...state.validationWarning,
            [slot]: {
                isValid,
                message,
            },
        },
    };
})
    .addCase(stytchWarning_1.stytchClearWarnings, (state) => {
    return {
        ...state,
        validationWarning: {},
    };
})
    .addCase(stytchGetCurrentUserSaga_1.stytchGetCurrentUserResponse, (state, { payload: { userAccountData } }) => {
    return {
        ...state,
        userAccountData,
    };
})
    // phone
    .addCase(stytchEmailSignInSaga_1.stytchEmailSignInResponse, (state, { payload }) => {
    return {
        ...state,
        email: payload,
    };
})
    .addCase(stytchEmailSignUpSaga_1.stytchEmailSignUpResponse, (state, { payload }) => {
    return {
        ...state,
        email: payload,
    };
})
    .addCase(stytchEmailResendMessageSaga_1.stytchEmailResendMessageResponse, (state, { payload }) => {
    return {
        ...state,
        email: payload,
    };
})
    .addCase(stytchEmailExchangeCodeSaga_1.stytchEmailExchangeCodeResponse, (state, { payload }) => {
    return {
        ...state,
        email: {
            ...state.email,
            ...payload,
        },
    };
})
    // crypto
    .addCase(stytchCryptoSignUpSaga_1.stytchCryptoSignUpResponse, (state, { payload }) => {
    return {
        ...state,
        crypto: payload,
    };
})
    .addCase(stytchCryptoSignInSaga_1.stytchCryptoSignInResponse, (state, { payload }) => {
    return {
        ...state,
        crypto: { ...state.crypto, ...payload },
    };
})
    .addCase(stytchCryptoExchangeCodeSaga_1.stytchCryptoExchangeCodeResponse, (state, { payload }) => {
    return {
        ...state,
        crypto: {
            ...state.crypto,
            ...payload,
        },
    };
})
    // phone
    .addCase(stytchPhoneSignInSaga_1.stytchPhoneSignInResponse, (state, { payload }) => {
    return {
        ...state,
        phone: payload,
    };
})
    .addCase(stytchPhoneSignUpSaga_1.stytchPhoneSignUpResponse, (state, { payload }) => {
    return {
        ...state,
        phone: payload,
    };
})
    .addCase(stytchPhoneExchangeCodeSaga_1.stytchPhoneExchangeCodeResponse, (state, { payload }) => {
    return {
        ...state,
        phone: {
            ...state.phone,
            ...payload,
        },
    };
})
    .addCase(stytchPhoneResendCodeSaga_1.stytchPhoneResendCodeResponse, (state, { payload }) => {
    return {
        ...state,
        phone: payload,
    };
}));
const stytchStateSelector = (state) => state.stytch;
exports.stytchStateSelector = stytchStateSelector;
exports.stytchAuthenticatedSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.isAuthenticated);
exports.stytchStepSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.step);
exports.stytchLoadingSlotSelector = (0, toolkit_1.createSelector)([
    exports.stytchStateSelector,
    (_state, stytchLoadingSlot) => stytchLoadingSlot,
], (_state, stytchLoadingSlot) => !!_state.loadingSlots[stytchLoadingSlot]);
exports.stytchLoadingSlotsSelector = (0, toolkit_1.createSelector)([
    exports.stytchStateSelector,
    (_state, stytchLoadingSlots) => stytchLoadingSlots,
], (_state, stytchLoadingSlots) => stytchLoadingSlots.reduce((prev, current) => prev || !!_state.loadingSlots[current], false));
exports.stytchWarningSlotSelector = (0, toolkit_1.createSelector)([
    exports.stytchStateSelector,
    (_state, stytchWarningSlot) => stytchWarningSlot,
], (_state, stytchWarningSlot) => _state.validationWarning[stytchWarningSlot]);
exports.stytchCryptoSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.crypto);
exports.stytchEmailSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.email);
exports.stytchPhoneSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.phone);
exports.stytchUserAccountDataSelector = (0, toolkit_1.createSelector)(exports.stytchStateSelector, (_state) => _state.userAccountData);
